import { Injectable } from '@angular/core';


import { AngularFireAuth } from '@angular/fire/auth';

import { Platform, AlertController } from '@ionic/angular';
// import { GooglePlus } from "@ionic-native/google-plus";
// import { TwitterConnect } from "@ionic-native/twitter-connect";
import { FirestoreService } from '../services/FirestoreService';

// import { Stripe } from '@ionic-native/stripe';
import { Observable } from 'rxjs';

@Injectable()
export class AuthService {
  public authState: AngularFireAuth;
  private firestore: FirestoreService;
  uid: any;
  cardDetails: {
    number: string;
    expMonth: number;
    expYear: number;
    cvc: string;
  };

  constructor(
    private alertCtrl: AlertController,
    public afAuth: AngularFireAuth,
    private platform: Platform,
    // private fb: Facebook,
    // private googlePlus: GooglePlus,
    private firestoreService: FirestoreService
  ) // private stripe: Stripe,
  // private twitter: TwitterConnect
  {
    afAuth.authState.subscribe((user: any) => {
      if (user) {
        this.uid = user.uid;
      } else {
        this.uid = null;
      }
    });
  }

  // signInWithFacebookPlugin() {
  //   if (this.platform.is("cordova")) {
  //     return this.fb
  //       .login(["email"])
  //       .then(res => {
  //         const facebookCredential = firebase.auth.FacebookAuthProvider.credential(
  //           res.authResponse.accessToken
  //         );

  //         firebase
  //           .auth()
  //           .signInWithCredential(facebookCredential)
  //           .then(
  //             res => { },
  //             err => {
  //               console.error("Error: ", err);
  //               throw err;
  //             }
  //           );
  //       })
  //       .catch(error => {
  //         throw error;
  //       });
  //   } else {
  //     return this.signInWithFacebookWeb();
  //   }
  // }

  // signInWithFacebookWeb() {
  //   return this.afAuth.auth
  //     .signInWithPopup(new firebase.auth.FacebookAuthProvider())
  //     .then(
  //       res => { },
  //       err => {
  //         console.error("Error: ", err);
  //         throw err;
  //       }
  //     );
  // }

  // signInWithGooglePlugin() {
  //   if (this.platform.is("cordova")) {
  //     return this.googlePlus
  //       .login({
  //         webClientId:
  //           "395983984847-84m1jgom088b1d8jdn36v6rspaov5nhp.apps.googleusercontent.com",
  //         offline: true
  //       })
  //       .then(
  //         res => {
  //           const googleCredential = firebase.auth.GoogleAuthProvider.credential(
  //             res.idToken
  //           );

  //           firebase
  //             .auth()
  //             .signInWithCredential(googleCredential)
  //             .then(response => {
  //               console.log("Firebase success: " + JSON.stringify(response));
  //             });
  //         },
  //         err => {
  //           console.error("Error: ", err);
  //           throw err;
  //         }
  //       );
  //   } else {
  //     return this.signInWithGoogleWeb();
  //   }
  // }

  // signInWithGoogleWeb() {
  //   return this.afAuth.auth
  //     .signInWithPopup(new firebase.auth.GoogleAuthProvider())
  //     .then(
  //       res => { },
  //       err => {
  //         console.error("Error: ", err);
  //         throw err;
  //       }
  //     );
  // }

  // signInWithTwitterPlugin() {
  //   if (this.platform.is("cordova")) {
  //     return this.twitter.login().then(
  //       function (result) {
  //         console.log("Successful login!");
  //         console.log(result);
  //       },
  //       function (error) {
  //         console.error("Error logging in");
  //         console.error(error);
  //         throw error;
  //       }
  //     );
  //   } else {
  //     return this.signInWithTwitterWeb();
  //   }
  // }

  // signInWithTwitterWeb() {
  //   return this.afAuth.auth
  //     .signInWithPopup(new firebase.auth.TwitterAuthProvider())
  //     .then(
  //       res => { },
  //       err => {
  //         console.error("Error: ", err);
  //         throw err;
  //       }
  //     );
  // }

  // signInWithGithub() {
  //   return this.afAuth.auth
  //     .signInWithPopup(new firebase.auth.GithubAuthProvider())
  //     .then(res => { });
  // }

  // payWithStripe(number, expMonth, expYear, cvc) {
  //   return new Observable((observer) => {
  //     this.stripe.setPublishableKey("pk_test_51I9uITK3V3KHgpW0GG21ort1MBumSoYIKYEogddAQbx0AAwAbpWCcEm2L4qzweeftxLVcRN0f4cF70v0ttg2eyZT007Luna0XG");

  //     this.cardDetails = {
  //       number: number,//'4242424242424242',
  //       expMonth: expMonth,//12,
  //       expYear: expYear, //2020,
  //       cvc: cvc//'220'
  //     }

  //     this.stripe.createCardToken(this.cardDetails)
  //       .then(token => {
  //         console.log("stipe token", token);
  //         this.makePayment(token.id).subscribe((event) => {
  //           observer.next(event);
  //         });
  //       })
  //       .catch(error => console.error(error));
  //   });

  // }

  makePayment(token) {
    return new Observable((observer) => {
      // console.log('token', token);
      observer.next(token);
    });
    // this.registerUser(email, pass);
  }

  async registerUser(name, email, password) {
    // console.log('name', name, email, password);
    return await this.afAuth
      .createUserWithEmailAndPassword(email, password)
      .then(async (res) => {
        await (
          await this.afAuth.currentUser
        ).updateProfile({ displayName: name, photoURL: null });
        // console.log('res', res);
        setTimeout(() => {
          this.firestoreService.addUser(name, email);
        }, 500);

        // this.firestore.addUser(name, email);
      })
      .catch((error) => {
        console.log('err', error);
        throw error;
      });
  }

  signIn(email, password) {
    return this.afAuth
      .signInWithEmailAndPassword(email, password)
      .then((res) => {
        console.log({ res });
      })
      .catch((error) => {
        console.log({ error });
        throw error;
      });
  }

  signOut(): void {
    this.authState.signOut();
    // firebase.auth().signOut();
  }

  async forgotPassword(email) {
    return this.authState.sendPasswordResetEmail(email)
      .then(async (s) => {
        let alert = await this.alertCtrl.create({
          header: 'Password Reset',
          subHeader: 'Check your inbox to reset your password',
          buttons: ['Dismiss'],
        });
        alert.present();
      })
      .catch((error) => {
        throw error;
      });
  }
}
